<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <v-textarea
          class="full-height editor_bg"
          v-model="procedure.content"
          solo
          no-resize
          auto-grow
          row-height="100%"
          spellcheck="false"
          hide-details="auto"
          :placeholder="`${pageTitle} 절차를 입력하세요`"
          :rules="rules"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// Components
import baseview from '@/views/base/baseview.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardRight from '@/components/common/iCardRight.vue'
import {
  getWorkerParticipationProcedure,
  getWorkerParticipationProcedureSample,
  getWorkerParticipationProcedureReport,
  saveWorkerParticipationProcedure,
  deleteWorkerParticipationProcedure
} from '@/api/procedure/workerParticipationProcedure.js'

export default {
  mixins: [baseview, iCardRight],
  components: {},
  data() {
    return {
      pageTitle: '근로자 참여',
      initCompId: '',
      rules: [value => !!value || '필수 입력값입니다.'],
      procedure: {
        clntId: '',
        content: ''
      }
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    }
  },
  created() {
    this.initCompId = this.getCompId()
    this.btnSearch(true)
  },
  beforeMount() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
  },
  mounted() {},
  activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  methods: {
    //////////////////////////////////////////////////////////////////////
    // 버튼 이벤트
    //////////////////////////////////////////////////////////////////////
    async btnSample(isNotify) {
      this.vToastifyPrompt(this.$t('작성중인 내용이 덮어집니다. 예시를 불러오시겠습니까?'), 'info', async current => {
        getWorkerParticipationProcedureSample(isNotify).then(response => {
          if (!response.success) {
            this.procedure = response
          } else {
            this.procedure.content = ''
          }
        })
        return
      })
    },
    async btnSearch(isNotify) {
      let param = {
        clntId: this.getClntId()
      }
      getWorkerParticipationProcedure(param, isNotify).then(response => {
        if (!response.success) {
          this.procedure = response
        } else {
          this.procedure.clntId = ''
          this.procedure.content = ''
        }
      })
    },
    btnSave() {
      
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.openLoading('saving')

          this.procedure.clntId = this.getClntId()
          saveWorkerParticipationProcedure(this.procedure, true)
            .then(response => {})
            .finally(() => {
              this.endLoading()
              this.btnSearch()
            })
        },
        null,
        true
      )
    },
    btnDelete() {
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.openLoading('deleting')
          this.procedure.clntId = this.getClntId()
          deleteWorkerParticipationProcedure(this.procedure, true)
            .then(response => {})
            .finally(() => {
              this.endLoading()
              this.btnSearch()
            })
        },
        null,
        true
      )
    },
    async btnPrint(type) {
      let data = this.procedure.content
      if (!data) {
        this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
        return
      }
      let param = {
        clntId: this.getClntId(),
        type: type
      }
      this.openLoading()
      getWorkerParticipationProcedureReport(param)
        .then(response => {
          this.downloadReport(response)
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    }
  }
}
</script>

<style lang="scss">
</style>
